import { defineStore } from 'pinia'
import axios from 'axios'
import CONSTANTS from '@/helpers/constants'
import { getCountry } from '@/plugins/global'
import { isFlag } from '@/plugins/feature-flags'
import { useCookies } from 'vue3-cookies'
const { cookies } = useCookies()

export const useLandingPage = defineStore('auth', {
	state: () => ({
		_referrerUserName: '',
		_trialDays: '',
		_referrer: {},
		_storeData: {},
		_customReferralPage: false,
		_customAd: false,
		_pageContent: {},
		_country: '',
		_threeDayTrial: false,
	}),
	getters: {
		referrer(state) {
			return state._referrer
		},
		pageContent(state) {
			return state._pageContent
		},
		referrerFirstName(state) {
			return this.hasReferrer ? state._referrer.user?.full_name?.split(' ')?.[0] : ''
		},
		referrerFullName(state) {
			return this.hasReferrer ? state._referrer?.user?.full_name : ''
		},
		hasReferrer: state => state._customReferralPage,
		hasAd: state => state._customAd,
		trialDays: state => state._trialDays,
		forceExperiment: state => state._customReferralPage || state._customAd,
		country: state => state?._country,
		threeDayTrial: state => state?._threeDayTrial,
	},
	actions: {
		async _initializeReferrer() {
			const urlString = window.location.href
			const url = new URL(urlString)
			this._referrerUserName = url.searchParams.get('ref') || ''
			//TODO: hardcoded case
			this._fakeProfile()
			this._referrerUserName && (await this._fetchReferrer())
		},
		_initalizeAdCampaign() {
			const urlString = window.location.href
			const url = new URL(urlString)
			const utmMedium = url.searchParams.get('utm_medium')
			const campaignKey = url.searchParams.get('offer_campaign') || url.searchParams.get('utm_campaign')
			return this._fetchAdContent(utmMedium, campaignKey)
		},
		_hasSupportedAdCampaign() {
			const urlString = window.location.href
			const url = new URL(urlString)
			const utmMedium = url.searchParams.get('utm_medium')
			const campaignKey = url.searchParams.get('offer_campaign') || url.searchParams.get('utm_campaign')
			return Boolean(CONSTANTS.AD_CONTENT[utmMedium] || CONSTANTS.AD_CONTENT.landing_page?.campaign?.[campaignKey])
		},
		// returns if the ad is supported
		_fetchAdContent(utmMedium, campaignKey) {
			const mediumContent = CONSTANTS.AD_CONTENT[utmMedium]
			const campaignContent = mediumContent?.campaign?.[campaignKey] || CONSTANTS.AD_CONTENT.landing_page?.campaign?.[campaignKey]
			if (!mediumContent && !campaignContent) return false
			this._customAd = true
			this._pageContent = campaignContent ? campaignContent.pageContent : mediumContent.campaign.defaultStanCampaign.pageContent
			return true
		},
		_initializeTrialDays() {
			const urlString = window.location.href
			const url = new URL(urlString)
			if (!this._trialDays?.length) this._trialDays = url.searchParams.get('trialDays') || ''
		},
		async initialize() {
			await this._initializeReferrer()
			const customRefOrTrialDaysOverride = this.hasReferrer || (!!this._trialDays?.length && !this._hasSupportedAdCampaign())

			!customRefOrTrialDaysOverride && this._initalizeAdCampaign()
			this._initializeTrialDays()
			getCountry().then(country => (this._country = country))
		},
		_fakeProfile() {
			const referrerUserNameLower = this._referrerUserName.toLowerCase()
			const profileKey = CONSTANTS.SIMON_SQUIBB_REFS.includes(referrerUserNameLower) ? 'simonsquibb' : referrerUserNameLower
			if (!CONSTANTS.FAKE_PROFILES[profileKey]) return false
			this._referrer = {
				user: { full_name: CONSTANTS.FAKE_PROFILES[profileKey].full_name },
			}
			this._pageContent = CONSTANTS.FAKE_PROFILES[profileKey].pageContent
			// Share Simon's page across regional referrals without changing attribution.
			if (profileKey === 'simonsquibb') {
				this._pageContent = { ...this._pageContent, ...CONSTANTS.SIMON_STANLEY_PAGE_CONTENT }
				this._trialDays = '30'
			}
			this._trialDays = CONSTANTS.FAKE_PROFILES[profileKey].trialDays || this._trialDays
			this._customReferralPage = true
			return true
		},
		_cleanProfile() {
			this._referrerUserName = ''
			this._referrer = {}
			this._trialDays = ''
			this._customReferralPage = false
			this._pageContent = {}
		},
		async _fetchReferrer() {
			try {
				const { data: response } = await axios.get('v1/stores', {
					params: { username: this._referrerUserName },
				})
				this._referrer.user = response.user
				this._storeData = response.storeData

				// Get trial days from referrer data
				const trialDays = this._referrer.user?.referral_trial_days ? this._referrer.user.referral_trial_days : -1
				if (!this._trialDays?.length && trialDays > 0 && trialDays != 14) {
					this._trialDays = `${trialDays}`
				}
			} catch (error) {
				if (!this._customReferralPage) {
					this._cleanProfile()
				}
			}
		},
	},
})
